export const navItems = [
  {
    name: "About",
    link: "#skill",
  },
  {
    name: "My Skills",
    link: "#about",
  },
  {
    name: "Projects",
    link: "#project1",
  },
  {
    name: "Contact",
    link: "#contact",
  }, 
];
